var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import React from 'react';
export var resolveMentionContext = function (nextText, cursorPosition) {
    if (cursorPosition === undefined)
        return null;
    var textUntilCursor = nextText.slice(0, cursorPosition);
    var atIndex = textUntilCursor.lastIndexOf('@');
    if (atIndex === -1)
        return null;
    var query = textUntilCursor.slice(atIndex + 1);
    if (query.includes(' '))
        return null;
    return { query: query, start: atIndex };
};
export var buildOverlayContent = function (text, activeMentions) {
    if (!text)
        return null;
    var cursor = 0;
    var content = [];
    var sortedMentions = __spreadArrays(activeMentions).sort(function (a, b) { return a.start - b.start; });
    sortedMentions.forEach(function (mention, index) {
        if (mention.start > cursor) {
            content.push(React.createElement('span', { key: "text-" + index + "-" + cursor }, text.slice(cursor, mention.start)));
        }
        content.push(React.createElement('span', { key: "mention-" + index + "-" + mention.start, 'data-mention': 'true' }, text.slice(mention.start, mention.end)));
        cursor = mention.end;
    });
    if (cursor < text.length) {
        content.push(React.createElement('span', { key: 'tail' }, text.slice(cursor)));
    }
    return content;
};
export var buildSelectionResult = function (_a) {
    var text = _a.text, mentionStart = _a.mentionStart, cursorPosition = _a.cursorPosition, user = _a.user, activeMentions = _a.activeMentions;
    var mentionLabel = "@" + user.fullName;
    var nextText = "" + text.slice(0, mentionStart) + mentionLabel + " " + text.slice(cursorPosition);
    var replacedLength = cursorPosition - mentionStart;
    var insertedLength = mentionLabel.length + 1;
    var shift = insertedLength - replacedLength;
    var shiftedMentions = activeMentions
        .map(function (mention) {
        if (mention.end <= mentionStart)
            return mention;
        if (mention.start >= cursorPosition) {
            return __assign(__assign({}, mention), { start: mention.start + shift, end: mention.end + shift });
        }
        return null;
    })
        .filter(function (mention) { return mention !== null; });
    var nextMentions = __spreadArrays(shiftedMentions, [
        {
            id: user.id,
            label: mentionLabel,
            start: mentionStart,
            end: mentionStart + mentionLabel.length,
        },
    ]);
    return {
        nextText: nextText,
        nextMentions: nextMentions,
        nextCursor: mentionStart + mentionLabel.length + 1,
    };
};
export var buildBackspaceDeletionResult = function (_a) {
    var text = _a.text, activeMentions = _a.activeMentions, cursor = _a.cursor;
    var mentionToDelete = activeMentions.find(function (mention) { return cursor > mention.start && cursor <= mention.end; });
    if (!mentionToDelete)
        return null;
    var nextText = text.slice(0, mentionToDelete.start) + text.slice(mentionToDelete.end);
    var shift = mentionToDelete.start - mentionToDelete.end;
    var nextMentions = activeMentions
        .filter(function (mention) { return mention !== mentionToDelete; })
        .map(function (mention) {
        if (mention.start >= mentionToDelete.end) {
            return __assign(__assign({}, mention), { start: mention.start + shift, end: mention.end + shift });
        }
        return mention;
    });
    return {
        nextText: nextText,
        nextMentions: nextMentions,
        nextCursor: mentionToDelete.start,
    };
};
